export default {
  //Journey
  "Iniciar Questionário": "Let's Start",
  "Confirmar Resposta": "Confirm Answer",
  "Próxima Questão": "Next Question",
  "Respondendo...": "Answering...",

  "Face Sul": "South Face",
  "Face Norte": "North Face",
  "Face Leste": "East Face",
  "Face Oeste": "West Face",

  // South
  Menos: "Less",
  "Me Identifico": "I Identify Myself",
  Mais: "More",

  // East
  "É importante que você trabalhe sem pressa e responda a todas as afirmações sinceramente.":
    "It's important that you answer the questions with patience and sincerely.",
  "Absolutamente não me identifico com a frase":
    "I absolutely do not identify with the phrase",
  "Descreve-me perfeitamente": "Describes me perfectly",
  "Você precisa preencher toda as questões!":
    "You need to answer all questions!",

  // West
  "pontos distribuídos": "distributed points",
  "Você precisa distribuir todos os": "You need to distribute all the",
  pontos: "points",

  // Complete
  Parabéns: "Congratulations",
  "Você concluiu com sucesso o questionário!":
    "You have successfully completed the questionnaire!",
  "Fazer Download do Relatório": "Download Report",
  "Quando disponível, você receberá um e-mail com o link para baixar seu relatório.":
    "When available, you will receive an email with the link to download the report."
};



// WEBPACK FOOTER //
// ./src/translations/en.js